export default __webpack_public_path__ + "static/media/BE.1a51c785.svg";